const refs = 'pages'
export default [
    { 
        path: '/page/:slug', 
        name: 'page', 
        component: () => import('@/views/'+refs+'/List.vue')
    },
    { 
        path: '/termsconditions', 
        name: 'termsconditions', 
        component: () => import('@/views/'+refs+'/termsConditions.vue')
    },
    { 
        path: '/privacypolicy', 
        name: 'privacypolicy', 
        component: () => import('@/views/'+refs+'/privacyPolicy.vue')
    },
    { 
        path: '/payment/success', 
        name: 'payment-success', 
        component: () => import('@/views/'+refs+'/successPayment.vue')
    },
    { 
        path: '/donationVoucherPayment/success', 
        name: 'successDonationVoucher', 
        component: () => import('@/views/'+refs+'/successDonationVoucher.vue')
    },
    { 
        path: '/paymentNomiation/success', 
        name: 'successNomination', 
        component: () => import('@/views/'+refs+'/successNomination.vue')
    },
    { 
        path: '/payment/error', 
        name: 'payment-error', 
        component: () => import('@/views/'+refs+'/errorPayment.vue')
    }
]
